import { extendTheme } from '@mui/joy/styles';

const theme = extendTheme({
  fontFamily: {
    body: 'var(--font-inter), Inter, system-ui, sans-serif',
    display: 'var(--font-figtree), Figtree, sans-serif',
    code: 'var(--font-ibm-plex-mono), "IBM Plex Mono", monospace',
  },
  radius: {
    xs: '2px',
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          50: '#e8eefc',
          100: '#c5d4f5',
          200: '#9fb6ec',
          300: '#85a6e9',
          400: '#5b86df',
          500: '#2862d7',
          600: '#305fbd',
          700: '#244a9a',
          800: '#1a3674',
          900: '#12244f',
        },
        background: {
          body: '#0e111b',
          surface: '#0d172b',
          level1: '#0d172b',
          level2: '#12244f',
          level3: '#172540',
        },
        divider: '#172540',
        text: {
          primary: '#ffffff',
          secondary: '#abaebb',
          tertiary: '#c7c9d1',
        },
      },
    },
    dark: {
      palette: {
        primary: {
          50: '#e8eefc',
          100: '#c5d4f5',
          200: '#9fb6ec',
          300: '#85a6e9',
          400: '#5b86df',
          500: '#2862d7',
          600: '#305fbd',
          700: '#244a9a',
          800: '#1a3674',
          900: '#12244f',
        },
        background: {
          body: '#0e111b',
          surface: '#0d172b',
          level1: '#0d172b',
          level2: '#12244f',
          level3: '#172540',
        },
        divider: '#172540',
        text: {
          primary: '#ffffff',
          secondary: '#abaebb',
          tertiary: '#c7c9d1',
        },
        neutral: {
          outlinedBorder: '#172540',
          outlinedColor: '#abaebb',
          softBg: '#151e32',
        },
      },
    },
  },
  components: {
    JoyButton: {
      styleOverrides: {
        root: {
          borderRadius: '9999px',
          fontWeight: 500,
        },
      },
    },
    JoyCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          borderColor: '#172540',
          boxShadow: 'rgba(0, 0, 0, 0.2) 0px 3px 16px 0px',
        },
      },
    },
    JoyInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
  },
});

export default theme;
